import { getConfigInfo } from '@vse/api/machinemotion';
import { getRemoteHost, setRemoteHost } from '@vse/api/api_request';
import { messageBox } from '@src/style/style';
import { EnvironmentVariables } from '@src/EnvironmentVariables';

export let mmHost; // address of machinemotion
export let pythonHost; // address of the python server on mm

// TODO GD Get rid of that global variable, we manage it via React now
let gHasFullAccess;

/**
 * Asynchronously allocate an execution engine and set the remote host to something that makes sense.
 * @returns {Promise<void>}
 */
export function setDefaultHost (isLocal) {
  if (isLocal) {
    return new Promise((resolve) => { resolve(_setDefaultRemoteHost()); });
  }
  else {
    return fetch('https://systems.vention.io/machine-motion/alloc_mm_runner?version=v2&isBoxSimulation=true&branch=path-following-vention-io')
      .then((response) => {
        if (!response.ok) {
          messageBox('Failed to allocate path folowing branch!');
          throw new Error('Failed to allocate path folowing branch');
        }

        return response.json();
      })
      .then(payload => {
        EnvironmentVariables.REMOTE_EXEC_ENGINE = payload.message;
        _setDefaultRemoteHost();
      });
  }
}

/**
 * Function to set the remote host address automatically
 */
function _setDefaultRemoteHost () {
  mmHost = window.location.hostname;
  pythonHost = `http://${mmHost}:3333`;

  if (EnvironmentVariables.REMOTE_EXEC_ENGINE !== undefined) {
    // We use a remote execution engine when running Cypress tests on the CI
    const { token, port } = EnvironmentVariables.REMOTE_EXEC_ENGINE;
    setRemoteHost(`https://systems.vention.io/machine-motion/passthrough/${token}/${port}`);
    console.log(`Remote Machine Motion detected, hostname is: ${getRemoteHost()}`);
  }
  else {
    setRemoteHost(`http://${mmHost}:3100`);
    console.log(`Local Machine Motion detected, hostname is: ${getRemoteHost()}`);
  }
}

/**
 * Function to detect if the device has a touch screen
 */
export function isTouchScreenDevice () {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

/**
 * @returns {boolean} True if the device is a Vention pendant
 * Check if the device is a Vention pendant
*/
export function isOnVentionPendant () {
  return isTouchScreenDevice();
}

/**
 * Fetches the machine motion config info.
 * The function will retry every 5 seconds until the config is successfully fetched.
 *
 * @param {(ConfigInfo) => void} onConfigInfoFetched
 * @returns {void} Nothing.
 */
export function fetchMachineMotionConfigInfo (onConfigInfoFetched) {
  const intervalSeconds = 5;
  let retryInterval = null;

  const fetchConfigInfo = () => {
    getConfigInfo(configInfo => {
      if (!configInfo) {
        messageBox(`Failed to retrieve Machine Motion configuration, will retry in ${intervalSeconds} seconds.`, 'error');
      }
      else {
        clearInterval(retryInterval);
        onConfigInfoFetched(configInfo);
      }
    });
  };

  fetchConfigInfo();
  retryInterval = setInterval(fetchConfigInfo, intervalSeconds * 1000);
}

/**
 * @param {(hasFullAccess: boolean) => void} pCompletion
 */
export function checkIfHasFullAccess (pCompletion) {
  if (gHasFullAccess != undefined) { pCompletion(gHasFullAccess); }
  fetch(`${getRemoteHost()}/v1/network/has_full_control_center_access`)
    .then(function (pResponse) {
      if (pResponse.status === 200) {
        return pResponse.json();
      }
      else {
        return pResponse.text().then(function (pText) {
          console.error('Failed to retrieve if we have full control center access. Reason: ' + pText, pResponse);
          return undefined;
        });
      }
    }).then(function (pValue) {
      if (pValue) {
        gHasFullAccess = pValue.hasFullAccess;
        pCompletion(gHasFullAccess);
      }
    }).catch(function () { console.error('main.js -- checkIfHasFullAccess -- error'); });
}

// TODO GD Used in VSE, get rid of it
window._main = {
  ifTouchScreen: isTouchScreenDevice, // Preserve the original naming
};
